import { Offer } from '../../../models/offer.model';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { UtilsService } from '../../../services/shared/utils/utils.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { CommonService } from '../../../services/shared/common/common.service';

@Component({
  selector: 'app-add-offer-modal',
  templateUrl: './add-offer-modal.component.html',
  styleUrl: './add-offer-modal.component.css'
})
export class AddOfferModalComponent {
  codeExists: boolean = false;
  updated: boolean = false;

  name: string = "";
  codes: string[] = [];
  listCodes: string[] = [];
  isRequired: boolean = true;
  hidden: boolean = false;
  expirationDelay: number | undefined;

  constructor(public dialogRef: MatDialogRef<AddOfferModalComponent>,
  @Inject(MAT_DIALOG_DATA) public data: { codes: string[] },
  private snackBar: SnackbarService,
  public translationService: TranslationService,
  public utils: UtilsService,
  public common: CommonService) {
    this.listCodes = data.codes;
  }

  ngOnInit(): void {

  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.codes.forEach(c => c = c.toUpperCase().replaceAll(' ', ''));
    if (this.codes.length > 0) {
      const offer: Offer = {
        name: this.name,
        code: this.codes,
        pages: [],
        isRequired: this.isRequired,
        hidden: this.hidden,
        expirationDelay: this.expirationDelay
      };

      this.dialogRef.close(offer);
    } else {
      this.snackBar.showError(this.translationService.translate('The code is invalid. Only alphanumeric characters and underscores are allowed.'));
    }
  }

  onInputChange(event: Event){
    const result = this.common.handleInputCode(event, this.listCodes);
    this.codeExists = result.exists;
  }
  onAddCode(event: MatChipInputEvent) {
    const added = this.common.addCode(
      event.value || '',
      this.codes,
      this.listCodes,
      this.utils
    );

    if (added){
      this.updated = true;
      event.chipInput!.clear();
    }
  }
  onRemoveCode(code: string): void {
    if (this.common.removeCode(code, this.codes, this.listCodes)) {
      this.updated = true;
    }
  }
}
